export const accountConsolePath = "/bff/account";

export function getUserEmailLabel(email?: string) {
  return email?.trim() || null;
}

export function navigateToAccountConsole(assign: (url: string) => void) {
  assign(accountConsolePath);
}
